import React, { useEffect, useState } from 'react';
import { makeStyles, MenuItem, FormControlLabel, useMediaQuery, Select } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	root: {
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		overflow: "hidden",
		padding: "5.5px 14px",
		minHeight: 25,
		display: "flex",
		alignItems: "center",
	},
  container: {
    placeItems: "normal",
    maxWidth: ({ isMobile }) => isMobile && 200,
    width: ({ isMobile, width }) => (isMobile ? 200 : width),
  },
  label: {
		minWidth: 120,
		marginRight: 10,
    color: ({ disabled, touched, hover }) =>
      (touched || hover) && !disabled ? theme.palette.primary.main : "black",
  },
}));

const SimpleDropdownRequest = ({ label, name, onChange, value, requestFunction, width=false, disabled, labelPos="top", style={}, containerClass="" }) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false)
	const [hover, setHover] = useState(false)
	const classes = useStyles({ isMobile, width, disabled, touched, hover });
  const [options, setOptions] = useState([])

  useEffect(() => {
    requestFunction(1, 100)
    .then(setOptions)
    .catch(console.log)
  }, [requestFunction])

	return (
		<FormControlLabel
    className={classes.container + ` ${containerClass}`}
    label={<p className={classes.label}>{label}</p>}
    labelPlacement={isMobile ? "top" : labelPos}
    control={
			<Select
				fullWidth
				displayEmpty
				style={style}
				value={value}
				onChange={onChange}
				classes={{root: classes.root}}
				variant="outlined"
				size="small"
				name={name}
				disabled={disabled}
				onMouseEnter={() => setHover(true)}
				onMouseLeave={() => setHover(false)}
				onBlur={() => setTouched(false)}
				onFocus={e => setTouched(true)}
			>
				<MenuItem value="">
					Seleccione una opción
				</MenuItem>
				{options.map(option => (
					<MenuItem key={option.value} value={option.value}>
						{option.text}
					</MenuItem>
				))}
			</Select>}
		/>
	);
};

export default SimpleDropdownRequest;
